import { memo } from "react";
import type { GridRowParams } from "@mui/x-data-grid";
import { MenuItem } from "consts/openBanking";
import { useBankingSDKConnectorsRecipientsPivotActions } from "features/openBanking/actions";
import { DeleteOpenBankingResource } from "../../shared/OpenBankingResource";

const DeleteBankingSDKConnectorsRecipientsPivot = (props: GridRowParams) => {
    const { deleteBankingSDKConnectorsRecipientsPivot } = useBankingSDKConnectorsRecipientsPivotActions();

    const deleteOpenBankingResource = async ({ row }: GridRowParams) => {
        const [request] = deleteBankingSDKConnectorsRecipientsPivot(row, {
            shouldNotifyOnSuccess: true
        });
        await request;
    };

    return (
        <DeleteOpenBankingResource
            {...props}
            menuItem={MenuItem.BankingSDKConnectorsRecipientsPivot}
            deleteOpenBankingResource={deleteOpenBankingResource}
            ModalProps={{
                titleSlot: `Delete ID=${props.row.coreId} Banking SDK Connectors Recipients Pivot`,
            }}
        >
            Are you sure you want to delete this Banking SDK Connectors Recipients Pivot?
        </DeleteOpenBankingResource>
    );
};

export default memo(DeleteBankingSDKConnectorsRecipientsPivot);
